import { render, staticRenderFns } from "./UserAccountEditForm.vue?vue&type=template&id=35a44915&scoped=true&"
import script from "./UserAccountEditForm.vue?vue&type=script&lang=ts&"
export * from "./UserAccountEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./UserAccountEditForm.vue?vue&type=style&index=0&id=35a44915&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a44915",
  null
  
)

export default component.exports